module.exports = __webpack_public_path__ + "static/media/10_chemi_fair.39703a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/10_chemi_fair.png
// module id = 707
// module chunks = 0